var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBackBtn)?_c('button',{on:{"click":_vm.backTo}},[_vm._v("\n  Back\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }